export const breakpoints = {
  sm: 0,
  md: 800,
} as const
